import styled from '../../theme/styled-with-theme';
import { mediaQueries } from '../../styles/media-queries';

export const ToggleWrapper = styled('div')`
  display: flex;
  background-color: ${({ theme }) => theme.color.quickStartGuideToggle};
  width: 100%;
  border-radius: ${({ theme }) => theme.borderRadius.input};
`;

export const Toggle = styled('div')<{
  active: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 50%;
  cursor: pointer;
  border-radius: ${({ theme }) => theme.borderRadius.input};
  background-color: ${({ theme, active }) =>
    active ? `${theme.color.white}` : 'transparent'};
  box-shadow: ${({ active }) =>
    active ? '0px 0px 16px rgba(0, 0, 0, 0.16)' : 'transparent'};
  font-weight: ${({ theme, active }) =>
    active ? theme.fontWeight.button : 'normal'};
  padding: ${({ theme }) => theme.spacing.sm};

  p {
    width: 60%;
    min-width: 130px;
  }

  ${mediaQueries.tablet} {
    padding: ${({ theme }) => `${theme.spacing.ml} ${theme.spacing.sm}`};

    p {
      max-width: none;
    }
  }
`;
